import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { InverseTables } from "../../../../Constant";
import { INVERS_TABLE, INVERS_TABLE_BODY, INVERS_TABLE_HEAD } from "../../../../Data/BootstrapTable/BasicTable";
import CommonTable from "../Common/CommonTable";

const InverseTable = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={InverseTables} span={INVERS_TABLE} table />
        <CommonTable tableClass="table-inverse" headData={INVERS_TABLE_HEAD} headRowClass="border-bottom-light">
          {INVERS_TABLE_BODY.map((data) => (
            <tr key={data.id}>
              <th scope="row">{data.id}</th>
              <td>{data.firstName}</td>
              <td>{data.lastName}</td>
              <td>{data.office}</td>
              <td>{data.position}</td>
              <td>{data.salary}</td>
              <td>{data.joinDate}</td>
              <td>{data.age}</td>
            </tr>
          ))}
        </CommonTable>
      </Card>
    </Col>
  );
};

export default InverseTable;
